<template>
  <div>
    <div ref="trigger">
      <slot :open="open"></slot>
    </div>
    <div ref="menu" style="display:none" v-show="is_open">
      <div class="tw-relative tw-z-50 tw-bg-light tw-shadow-xl tw-min-w-4xl tw-border-t-4 tw-border-secondary">
        <div class="tw-flex" style="width:970px;min-height:300px">
          <div class="tw-w-80 tw-bg-light-4">
            <div v-for="category in categories" class="tw-p-3 cursor:tw-bg-light-6"
              :class="{'tw-bg-light-6' : current.id === category.id }"
              v-on:mouseover="current = category">{{category.title}}
            </div>
          </div>
          <div class="tw-flex-1">
            <div class="tw-flex">
              <div v-for="visibleCategoryGroup in visibleCategoryGroups" class="tw-w-1/3 tw-border-r tw-border-light-8 last:tw-border-r-0">
                <a v-for="visibleCategory in visibleCategoryGroup" class="tw-block tw-p-3"
                  :href="visibleCategory.url" :title="visibleCategory.title">{{visibleCategory.title}}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {createPopper} from "@popperjs/core";

  export default {
    props: {
      categories: {},
    },
    data: v => ({
      current: v.categories[0],
      is_open: false,
    }),
    created() {
      this.open = _.throttle(() => {
        this.needsRefresh && this.refresh()
        this.is_open = true
      }, 100)
      this.close = _.throttle(() => this.is_open = false, 100)

      let documentClickCallback = ev => {
        if (ev.target !== this.$el && !this.$el.contains(ev.target) && ev.target !== document.getElementById('topMenu')) {
          this.close();
        }
      }
      this.$on('hook:mounted', () => document.addEventListener('click', documentClickCallback))
      this.$on('hook:beforeDestroy', () => document.removeEventListener('click', documentClickCallback))
       this.$on('hook:mounted', () => document.addEventListener('mouseover', documentClickCallback))
      this.$on('hook:beforeDestroy', () => document.removeEventListener('mouseover', documentClickCallback))
    },
    computed: {
      visibleCategoryGroups() {
        return _.chunk(this.current.children,8)
      }
    },
    watch: {
      is_open(value) {
        value && createPopper(this.$refs.trigger, this.$refs.menu, {
          placement: "bottom-start",
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, 10],
              },
            },
          ],
        })
      }
    }
  }
</script>
